import { createApi } from "./common";

export const searchMaterials =
  ({ search, withArchived }) =>
  (token) =>
    createApi(
      "GET",
      `material/?search=${search}&with_archived=${withArchived}`
    )(token);
